import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export const FiltrosItensBloqueioAdministrativoSchema = yup.object().shape({
  idsLotes: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  idsProcessos: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  dadosVeiculos: yup
    .array()
    .of(yup.string().typeError("Dado inválido"))
    .optional()
    .nullable(),
  situacao: yup.string().optional().nullable(),
  idEmpresa: yup.number().optional().nullable(),
  cnpj: yup.string().optional().nullable(),
  dataCriacaoLote: yup.array().optional().nullable(),
  statusSolicitacao: yup.string().optional().nullable(),
});
